module.exports = __webpack_public_path__ + "static/img/top-logo2.4f61552.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top-logo2.png
// module id = gkWF
// module chunks = 0